module.exports = __webpack_public_path__ + "img/file-long-inverse.8ccc0bed.svg";